import React from "react";

export default function GalleryBlock({ data }) {
  const images = data.images || [
    "https://via.placeholder.com/300",
    "https://via.placeholder.com/300",
  ];

  return (
    <div style={{ marginTop: "20px", color: "white" }}>
      <h2>Gallery</h2>

      <div style={{ display: "flex", gap: "15px", marginTop: "10px" }}>
        {images.map((src, i) => (
          <img
            key={i}
            src={src}
            alt=""
            style={{ width: "200px", borderRadius: "12px" }}
          />
        ))}
      </div>
    </div>
  );
}
